import React from 'react';
import { CHECKOUT_URL, PURCHASE_ANCHOR } from '../data/content';
interface CTAButtonProps {
  label: string;
  sub?: string;
  target?: 'purchase' | 'checkout';
  className?: string;
}
export function CTAButton({
  label,
  sub,
  target = 'purchase',
  className = ''
}: CTAButtonProps) {
  return <a href={target === 'checkout' ? CHECKOUT_URL : PURCHASE_ANCHOR} className={`block w-full rounded-md border-2 border-white/30 bg-electric px-3 py-3 text-center font-heading text-[0.9rem] font-extrabold uppercase leading-tight tracking-wide text-navy shadow-[0_5px_0_0_#1769AA] transition-[filter,transform,box-shadow] duration-150 ease-out hover:brightness-110 active:translate-y-[3px] active:shadow-[0_2px_0_0_#1769AA] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/60 sm:text-lg ${className}`} data-id="element-29" data-mp="2fz1z6gy9kmsv">
      {label}
      {sub ? <span className="mt-0.5 block font-body text-xs font-semibold normal-case tracking-normal text-navy/80" data-id="element-30" data-mp="3cnhqahh0v483">
          {sub}
        </span> : null}
    </a>;
}